var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPants(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.58,887.34l-37.74-453-6.33-76-7.06-84.65-6.33-76-5.2-62.34a8,8,0,0,0-8-7.34H262.67a8,8,0,0,0-8,7.34l-5.19,62.34-6.33,76-7.06,84.65-6.33,76L192,887.34a8,8,0,0,0,8,8.66H440.84a8,8,0,0,0,7.82-6.32l62.65-292.35L574,889.68a8,8,0,0,0,7.82,6.32H822.61A8,8,0,0,0,830.58,887.34ZM724.34,383.06a64.11,64.11,0,0,1-53-63.06h47.78ZM314,194.78l.23-2.78H708.42l.23,2.78,5.1,61.22H308.87ZM303.53,320h47.78a64.11,64.11,0,0,1-53,63.06ZM478.66,448,391.8,832H260.87l32-384.12A128,128,0,0,0,415.31,320h64V448ZM630.82,832,544,448h-.65V320h64A128,128,0,0,0,729.74,447.88l32,384.12Z",
    style: {
      fill: "#000812"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPants);
export default __webpack_public_path__ + "static/media/pants.253bf5617bf59dfa691e5469fe611e7f.svg";
export { ForwardRef as ReactComponent };